import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-acts-page',
  templateUrl: './other-acts-page.component.html',
  styleUrls: ['./other-acts-page.component.css']
})
export class OtherActsPageComponent implements OnInit {
  // title="PSARA and Other Acts";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/Main/other-acts-page/other-acts-page.component.ts